export const VALUE_MASS_UPDATE_CHECKBOX = {
  sectionAll: 'section_all',
  categoryAll: 'category_all',
};
